import React from 'react';
import { Tabs } from 'antd';
import WmsLayout from '../layouts/WmsLayout';
import ConsolidationPage from './ConsolidationPage';

const { TabPane } = Tabs;

const ConsolidationTabManager: React.FC = () => {
    return (
            <Tabs 
                defaultActiveKey="swiftx" 
                type="card"
                className="h-full flex flex-col [&_.ant-tabs-content-holder]:flex-1 [&_.ant-tabs-content]:h-full [&_.ant-tabs-tabpane]:h-full"
            >
                <TabPane tab="SwiftX" key="swiftx">
                    <ConsolidationPage />
                </TabPane>
                {/* 「其他尾程商」tab 已隐藏，页面组件 ConsolidationPageOtherCarrier 保留，恢复时把对应 TabPane 加回即可 */}
            </Tabs>
    );
};

export default ConsolidationTabManager;
